import { render } from "./ThTerm.vue?vue&type=template&id=73ea91e2&scoped=true"
import script from "./ThTerm.vue?vue&type=script&scoped=true&lang=js"
export * from "./ThTerm.vue?vue&type=script&scoped=true&lang=js"

import "../../../../assets/css/agreement.css?vue&type=style&index=0&id=73ea91e2&scoped=true&lang=css"
import "./ThTerm.vue?vue&type=style&index=1&id=73ea91e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-73ea91e2"

export default script